import request from '@/utils/request'

// 资金明细 列表
export function getFundsDetailList(params) {
  return request({
    url: '/funds/detail',
    method: 'get',
    params: params
  })
}
// 缴纳保证金
export function payFunds(data) {
  return request({
    url: '/mch/account/pay',
    method: 'post',
    data:data
  })
}

// 商品充值
export function payLitting(data) {
  return request({
    url: '/mch/account/payLitting',
    method: 'post',
    data:data
  })
}
// 缴纳保证金
export function payPositionFunds(data) {
  return request({
    url: '/mch/account/position/pay',
    method: 'post',
    data:data
  })
}
// 获取当前支付的状态
export function payResult(params) {
  return request({
    url: '/mch/account/pay/order',
    method: 'get',
    params:params
  })
}

// 获取当前支付的状态
export function payPositionResult(params) {
  return request({
    url: '/mch/account/pay/position/order',
    method: 'get',
    params:params
  })
}



// WEBPACK FOOTER //
// ./src/api/funds.js